import {Text} from '@chakra-ui/react';

export const Bold = (chunks: React.ReactNode[]) => (
  <Text as="span" fontWeight="bold">
    {chunks}
  </Text>
);

export const Br = () => <br />;
